import { MapCell } from "../models/warehouse.mapcell";
import BaseService from "./_base.service";

const endpoint = "map-cells";

const WarehouseMapCellService = {
  ...BaseService<MapCell>({ endpoint }),
};

export default WarehouseMapCellService;
